<template>
  <SafetyStatisics />
</template>

<script>
import SafetyStatisics from '@/components/safetyStatisticsCard.vue';

export default {
  components: {
    SafetyStatisics,
  },
};
</script>

<style></style>
